import { computed } from 'vue';
import { Locale } from '@/i18n.ts';
import { DATE_PICKER_CONFIG_EN, DATE_PICKER_CONFIG_RU } from '@/modules/common/consts/date.ts';
import { useI18n } from 'vue-i18n';

export function useDatePickerLocale() {
  const { locale } = useI18n();

  return computed(() => {
    switch (locale.value) {
      case Locale.RuRU:
        return DATE_PICKER_CONFIG_RU;
      case Locale.EnUS:
      default:
        return DATE_PICKER_CONFIG_EN;
    }
  });
}
